import { Client } from '@outdoorly/chat-sdk';
import { createContext } from 'react';

export type RemarkContext = {
  client: Client | undefined;
  inProvider: boolean;
};
export const RemarkContext = createContext<RemarkContext>({ client: undefined, inProvider: false });
